document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.matrix-picker').forEach((picker) => {
    // Core refs
    const shadeNameEl = picker.querySelector('[data-matrix-shade-name]');
    const messageEl = picker.querySelector('[data-matrix-message]');
    const swatches = Array.from(picker.querySelectorAll('.matrix-picker__swatch'));

    // Current product + active variant label
    const currentProductId = String(picker.dataset.currentProductId);
    let activeShadeName = picker.dataset.currentVariantName || '';

    // Mobile helper for matrix scroll after page change
    const isMobileViewport = () => window.matchMedia('(max-width: 800px)').matches;
    const matrixAnchorId = 'matrix-picker';

    if (isMobileViewport() && sessionStorage.getItem('matrixScrollOnLoad') === '1') {
      window.setTimeout(() => {
        const matrixEl = document.getElementById(matrixAnchorId);
        if (matrixEl) {
          matrixEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        sessionStorage.removeItem('matrixScrollOnLoad');
      }, 250);
    }

    // Frontend-only display names for special cases
    const prettyVariantName = (name) => {
      const map = {
        'Apres Ski-44R': 'Après-Ski-44R',
        'Top Chic-38N': 'Top-Chic-38N',
      };

      return map[name] || name;
    };

    // Update visible shade name above matrix
    const setShadeName = (text) => {
      if (shadeNameEl) {
        shadeNameEl.textContent = prettyVariantName(text || activeShadeName);
      }
    };

    // Update info / hint text with fade
    const setMessage = (html) => {
      if (!messageEl) return;

      messageEl.classList.add('matrix-picker__is-fading');

      window.setTimeout(() => {
        messageEl.innerHTML = html || '&nbsp;';
        messageEl.classList.remove('matrix-picker__is-fading');
      }, 90);
    };

    // Remove active visual state from all swatches
    const clearSelected = () => {
      swatches.forEach((btn) => btn.classList.remove('is-selected'));
    };

    // Sync matrix click with the hidden native Shopify variant picker
    const selectNativeVariant = (variantId) => {
      const targetId = String(variantId);
      let variantData = null;

      document
        .querySelectorAll('variant-radios script[type="application/json"], variant-selects script[type="application/json"]')
        .forEach((script) => {
          if (variantData) return;

          try {
            const variants = JSON.parse(script.textContent);
            const match = variants.find((v) => String(v.id) === targetId);
            if (match) variantData = match;
          } catch (e) {}
        });

      // Fallback: just set hidden id input + URL
      if (!variantData) {
        document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
          input.value = targetId;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        const url = new URL(window.location.href);
        url.searchParams.set('variant', targetId);
        window.history.replaceState({}, '', url.toString());
        return;
      }

      // Update hidden radio-based pickers
      document.querySelectorAll('variant-radios').forEach((variantRadios) => {
        const fieldsets = variantRadios.querySelectorAll('fieldset');

        fieldsets.forEach((fieldset, index) => {
          const optionValue = variantData.options[index];
          if (!optionValue) return;

          const radio = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(
            (input) => input.value === optionValue
          );

          if (radio) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });

      // Update hidden select-based pickers
      document.querySelectorAll('variant-selects').forEach((variantSelects) => {
        const selects = variantSelects.querySelectorAll('select');

        selects.forEach((select, index) => {
          const optionValue = variantData.options[index];
          if (!optionValue) return;

          select.value = optionValue;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // Sync add-to-cart form input
      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
        input.value = targetId;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      // Update URL variant param
      const url = new URL(window.location.href);
      url.searchParams.set('variant', targetId);
      window.history.replaceState({}, '', url.toString());
    };

    // Hint text for unavailable swatches
    const getMessageForButton = (btn) => {
      const isCurrentProduct = btn.dataset.variantProductId === currentProductId;
      const currentAvailable = btn.dataset.currentAvailable === 'true';
      const sisterAvailable = btn.dataset.sisterAvailable === 'true';
      const sisterUrl = btn.dataset.sisterUrl || '#';
      const sisterLabel = btn.dataset.sisterLabel || 'anderen Größe';

      if (isCurrentProduct && currentAvailable) return '';

      if (sisterAvailable) {
        if (isMobileViewport()) {
          return `Nur in unserer <button type="button" class="matrix-picker__message-action" data-href="${sisterUrl}">${sisterLabel}</button> erhältlich.`;
        }
        return `Nur in unserer ${sisterLabel} erhältlich.`;
      }

      return 'Aktuell ausverkauft.';
    };

    // Hover + click behavior for matrix swatches
    swatches.forEach((btn) => {
      btn.addEventListener('mouseenter', () => {
        setShadeName(btn.dataset.variantName || activeShadeName);
        setMessage(getMessageForButton(btn));
      });

      btn.addEventListener('mouseleave', () => {
        setShadeName(activeShadeName);
        setMessage('');
      });

      btn.addEventListener('click', () => {
        const isCurrentProduct = btn.dataset.variantProductId === currentProductId;
        const currentAvailable = btn.dataset.currentAvailable === 'true';

        setShadeName(btn.dataset.variantName || activeShadeName);

        if (isCurrentProduct && currentAvailable) {
          clearSelected();
          btn.classList.add('is-selected');
          activeShadeName = btn.dataset.variantName || activeShadeName;
          setShadeName(activeShadeName);
          setMessage('');
          selectNativeVariant(btn.dataset.variantId);
          return;
        }

        setMessage(getMessageForButton(btn));
      });
    });

    // Mobile-only hint action to jump to sister product
    const handleMessageAction = (event) => {
      const action = event.target.closest('.matrix-picker__message-action');
      if (!action || !isMobileViewport()) return;

      event.preventDefault();
      event.stopPropagation();

      const href = action.getAttribute('data-href');
      if (!href) return;

      sessionStorage.setItem('matrixScrollOnLoad', '1');
      window.location.assign(href);
    };

    if (messageEl) {
      messageEl.addEventListener('click', handleMessageAction);
      messageEl.addEventListener('touchend', handleMessageAction, { passive: false });
    }

    // Mobile-only: keep matrix in view after switching size/product
    picker.querySelectorAll('.matrix-picker__size-button').forEach((button) => {
      button.addEventListener('click', () => {
        if (isMobileViewport()) {
          sessionStorage.setItem('matrixScrollOnLoad', '1');
        }
      });
    });

    // Initial state
    setShadeName(activeShadeName);
    setMessage('');
  });
});